import React from "react";
import Link from "next/link";
import FirmIndividualTilesServices from "./FirmIndividualTilesServices";
import CustomIcon from "../CustomIcon";
import FirmHelpPanel from "../FormComponents/FirmHelpPanel";
import {getOrderedServicesFromIds, getVerticalIdFromFirmType} from "../../data/attributeHelper";
import TopRatedIndividualTileLabel from "./TopRatedIndividualTileLabel";
import {FIRM_TYPES} from "../../__constants__";
import StarRatingDisplay from "../StarRatingDisplay";

import ApartmentIcon from "../vectors/ApartmentIcon";
import VerifiedUserOutlinedIcon from "../vectors/VerifiedUserOutlinedIcon";
import Button from "../Inputs/Button";
import {startCase} from "lodash";

const FirmSearchIndividualTile = ({item, index}) => {
    const metadata = item.metadata;
    const verticalId = getVerticalIdFromFirmType(metadata.firm_type);
    const services = getOrderedServicesFromIds(metadata.service_ids, verticalId);
    const profileLink = "/" + (metadata.profile_url ? metadata.profile_url : '404');

    return (
        <>
            {index === 0 && (
                <div className={`flex justify-center mb-0 lg:mb-[12px]`}>
                    <p className={`bg-mint-green py-[6px] px-[12px] text-primary-blue font-bold
                     rounded-tl-2xl rounded-tr-2xl text-[1.1rem] leading[1.5] m-0`}>
                        Closest to you
                    </p>
                </div>
            )}
            <div
                className={`${index === 0 ? 'border-solid border-mint-green border-4' : ''} 
                w-full m-0  pt-2 bg-white 
                mb-12 max-md:m-0 max-md:w-full
                flex flex-wrap box-border
                shadow-lg drop-shadow-lg
                
                `}
            >
                <div className={`p-[12px] flex-grow-0 max-w-[16.66%] basis-[16.667%] flex flex-col items-center m-0 box-border 
                    max-sm:inline-flex max-sm:flex-row max-sm:p-2 max-sm:max-w-full max-sm:basis-full max-sm:grow-0 `}>
                    {metadata.avatar ?
                        <Link href={profileLink}>
                            <div
                                className='cursor-pointer max-sm:max-w-[88px] max-sm:w-full max-sm:pr-2 inline box-content'>
                                <div className={`w-[130px] h=[130px] relative border-[3px] border-solid border-pale-mint-green p-[3px] 
                                rounded-full items-center leading-[1] max-sm:w-[calc(100%-14px)] max-sm:h-[calc(100%-14px)]`}>
                                    <img
                                        src={metadata.avatar}
                                        alt={'Firm profile image'}
                                        className={"w-full h-full object-cover text-center rounded-[50%]"}
                                    />
                                </div>
                            </div>
                        </Link>
                        :
                        <Link href={profileLink}>
                            <div
                                className={`box-content cursor-pointer [&>svg]:rounded-[50%] [&>svg]:border-solid [&>svg]:border-transparent [&>svg]:bg-contrast-blue max-sm:max-w-[88px] max-sm:w-full max-sm:pr-2 max-sm:inline                            `}>
                                <ApartmentIcon
                                    className={`w-[130px] h-[130px] relative border-3px border-solid border-pale-mint-green p-[3px] max-sm:w-[calc(100%-14px)] max-sm:h-[calc(100%-14px)]`}/>
                            </div>
                        </Link>
                    }
                    <div className='inline max-sm:hidden'>
                        <div className='pt-2 pl-2 w-full no-underline text-center'>
                            <Link href={profileLink}>
                                <a className='cursor-pointer relative block max-md:mt-4 [&:after]:absolute [&:after]:top-0 [&:after]:left-0 [&:after]:right-0 [&:after]:bottom-0'>
                                    <StarRatingDisplay
                                        rating={Math.round(metadata.surveys_score)}
                                        pixelSize={'20px'}
                                        centered
                                    />
                                </a>
                            </Link>
                        </div>
                        {metadata.survey_count ?
                            <>
                                <p className='pt-2 pl-2 w-full no-underline text-center text-[1.1rem] leading-[1.5] m-0'>
                                    <Link
                                        passHref
                                        href={profileLink}
                                    >
                                        <b className="test-firm-surveys">{`${metadata.survey_count} reviews`}</b>
                                    </Link>
                                </p>
                                {(metadata.surveys_score != 0) &&
                                    <div className='text-center'>
                                        <Link href={profileLink} passHref>
                                            <a className='test-survey-firm-average pt-2 pl-2 w-full no-underline text-primary-blue text-[0.875rem] leading-[1.43]'>
                                                <b>{`${metadata.surveys_score} out of 5`}</b>
                                            </a>
                                        </Link>
                                    </div>
                                }
                            </>
                            :
                            <p className='w-full text-center pt-2 no-underline text-[1.1rem] leading-[1.5] m-0'>
                                No reviews yet
                            </p>
                        }
                    </div>
                    <div className='inline sm:hidden'>
                        <div className={`flex flex-col justify-center max-sm:inline`}>
                            <Link href={profileLink}>
                                <a className='no-underline cursor-pointer'>
                                    <h6 className="test-firm-name text-primary-blue text-[1.25rem] leading-[1.6] m-0 font-bold">
                                        {metadata.name}
                                    </h6>
                                </a>
                            </Link>
                            <div
                                className='pt-2 pl-2 w-full no-underline text-center max-sm:[text-left] max-sm:flex max-sm:text-center '>
                                <div className='max-w-full'>
                                    <Link href={profileLink}>
                                        <a className='cursor-pointer relative block'>
                                            <StarRatingDisplay
                                                rating={Math.round(metadata.surveys_score)}
                                                pixelSize={'12px'}
                                            />
                                        </a>
                                    </Link>
                                </div>
                                <p className='pl-[6px] text-[13px] leading-[1.43] m-0'>
                                    <Link href={profileLink}>
                                        <a className='test-firm-reviews no-underline  cursor-pointer'>
                                            {`${metadata.survey_count} reviews`}
                                        </a>
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className='p-3 overflow-hidden relative grow-0 max-w-[83.33%] basis-[83.33%] m-0 box-border max-sm:max-w-full max-sm:basis-full '>
                    <div className='w-full flex flex-wrap box-border'>
                        <div className='max-sm:hidden inline w-full'>
                            <div className='flex'>
                                <div className='grow-0 max-w-[50%] basis-[50%] m-0 box-border'>
                                    <Link href={profileLink}>
                                        <h6 className='mt-2 mb-4 cursor-pointer text-xl leading-[1.6] font-bold m-0'>
                                            {metadata.name}
                                        </h6>
                                    </Link>
                                </div>
                                <div
                                    className='flex w-full flex-wrap grow-0 max-w-[50%] basis-[50%] justify-end items-center m-0 box-border '>
                                    <Link href={profileLink} passHref>
                                        <Button
                                            className='min-w-[128px] min-h-12 sm:text-[16px] mr-[3rem]'
                                            dataTest={'firm-'+item.id+'-btn'}
                                            text='View Firm'
                                        />
                                    </Link>
                                </div>
                            </div>
                            <div className='grow-0 max-w-full basis-full m-0 box-border'>
                                <div className='max-xs:hidden'>
                                    <hr className='my-4 mx-2 border-none h-[1px] bg-[rgba(0,0,0,0.12)]'/>
                                </div>
                            </div>
                        </div>
                        <div className='flex sm:hidden flex-wrap w-[calc(100%+16px)] p-1 -mx-2 mb-2'>
                            <TopRatedIndividualTileLabel
                                isTopRated={metadata.top_rated}
                                variant="mobile"
                            />
                        </div>
                        {metadata.about && (
                            <div
                                className='text-primary-blue max-sm:p-0 max-sm:max-w-full max-sm:basis-full max-w-[300px] pt-4 pr-4 pb-0 pl-0 grow-0 basis-[33.33%] m-0 box-border'>
                                <p className='text-primary-blue text-[0.875rem] leading-1.43 m-0'>
                                    <div className='hidden max-sm:inline'>
                                        {`${(metadata.about).substring(0, 110)}...`}
                                    </div>
                                    <div className='inline max-sm:hidden'>
                                        {`${(metadata.about).substring(0, 180)}...`}
                                    </div>
                                    <Link href={profileLink}>
                                        <a className='no-underline cursor-pointer text-secondary-blue test-firm-description'>
                                            more
                                        </a>
                                    </Link>
                                </p>
                            </div>
                        )}
                        <div className={`grow-0 max-xs:max-w-full max-xs:basis-full max-w-[33.33%] basis-[33.33%] m-0 box-border
                            ${metadata.about ? 'pt-4 pr-4 pb-0 pl-4 max-sm:pt-4 max-sm:pr-2 max-sm:pb-4 max-sm:pl-0' :
                            'pt-4 pr-4 pb-0 pl-0 max-sm:p-0 max-md:max-w-full max-w-[300px] '}`}>
                            {metadata.firm_type === FIRM_TYPES.ADVISER && (
                                metadata.fca_regulated ?
                                    <div className='max-w-full m-0 box-border'>
                                        <div className='inline-flex mb-[0.3rem] pb-[0.2rem]'>
                                            <VerifiedUserOutlinedIcon
                                                className="text-[1.5rem] h-[1em] w-[1em] text-current"/>
                                            <p className='uppercase text-sm leading-[1.43] m-0'>
                                                Firm is FCA Regulated
                                            </p>
                                        </div>
                                    </div>
                                    :
                                    <div className='max-w-full m-0 box-border'>
                                        <div className='inline-flex mb-[0.3rem] pb-[0.2rem]'>
                                            <CustomIcon icon="question" color="navy" classes="[&_svg]:w-3 [&_svg]:h-3 mr-2"/>
                                            <p className='uppercase text-sm leading-[1.43] m-0'>
                                                FCA Authorisation Check Pending
                                            </p>
                                        </div>
                                    </div>
                            )}
                            {metadata.town && (
                                <div className='max-w-full m-0 box-border'>
                                    <div className='inline-flex mb-[0.3rem] pb-[0.2rem]'>
                                        <CustomIcon icon="location" color="navy" classes="[&_svg]:w-5 [&_svg]:h-5 border-none"/>
                                        <p className='text-sm leading-[1.43] m-0'>
                                            {startCase(metadata.town.toLowerCase())} ({item.distance.toFixed(2)} miles
                                            away)
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div
                            className='max-sm:hidden pt-4 pr-4 pb-0 pl-0 max-sm:p-0 grow-0 max-w-[33.33%] basis-[33.33%] m-0 box-border'>
                            {(services && services.length > 0) && (
                                <FirmIndividualTilesServices services={services} profileLink={profileLink}/>
                            )}
                        </div>
                        <div className='sm:hidden  inline w-full'>
                            <div className='flex-grow-0 max-w-full basis-full m-0 box-border'>
                                <Link href={profileLink} passHref>
                                    <Button
                                        text='View Firm'
                                        className='bg-primary-blue w-full min-w-[128px] min-h-12 text-[16px] mr-[3rem] flex-grow-0 max-w-full basis-full m-0 box-border '
                                        dataTest={'firm-'+item.id+'-btn'}
                                    />
                                </Link>
                            </div>
                        </div>
                        <div className='max-sm:hidden inline '>
                            <TopRatedIndividualTileLabel isTopRated={metadata.top_rated}/>
                        </div>
                    </div>
                </div>
            </div>
            {index === 2 && (
                <div className='mb-12 max-md:m-0 max-md:w-full'>
                    <div className='max-md:my-2 max-md:mx-1 p-2 grow-0 max-w-full basis-full box-border'>
                        <FirmHelpPanel/>
                    </div>
                </div>
            )}
        </>
    );
};

export default FirmSearchIndividualTile;